import { Component, Input } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertContact, ContactVerification } from "app/shared/models/Alerts";
import { AnnouncementsService } from "app/layout/announcements/announcements.service";
import { EvoToastr } from "app/shared/services/EvoToastr.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { EvoPatternValidator } from "app/shared/validators/evo-pattern-validator.directive";
import { FormatService } from "app/shared/services/format.service";
import { FormsValidationService } from "app/shared/services/formsValidation.service";
import { SubscriptionLike as ISubscription, Observable, forkJoin } from "rxjs";
import { BindingContext } from "app/shared/models/BindingContext";

@Component({
	selector: "contact-editor-modal",
	styleUrls: ["./contact-editor.component.scss"],
	templateUrl: "contact-editor.component.html",
})
export class ContactEditorComponent {
	bindingContext: BindingContext = new BindingContext();
	public actionType: string = "Add";
	public title: string = "Add Contact";
	public defaultForm;
	private subscription: ISubscription;
	private formValidatorSub: ISubscription;

	private _formValid: boolean;
	public set FormValid(input: boolean) {
		this._formValid = input;
	}
	public get FormValid(): boolean {
		return this._formValid;
	}

	constructor(
		public activeModal: NgbActiveModal,
		private annSvc: AnnouncementsService,
		private toastSvc: EvoToastr,
		private formatSvc: FormatService,
		private formSvc: FormsValidationService
	) {
		// Initialize the form
		this.CreateForm();
	}

	ngOnInit() {}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
		if (this.formValidatorSub) {
			this.formValidatorSub.unsubscribe();
		}
	}

	addContact() {
		this.bindingContext.beginGet();
		let contact = new AlertContact();
		let tempcontact: ContactVerification = new ContactVerification();
		this.formSvc.BindFormGroupToData(this.defaultForm, contact);
		tempcontact.Email = contact.Email;
		tempcontact.SMSPhone = contact.SMSPhone;
		this.annSvc
			.InsertAlertContact(contact)
			.then((resp) => {
				// We inserted the contact, send a verification
				let ary: Array<Observable<any>> = new Array<Observable<any>>();
				if (tempcontact.Email) {
					console.log("contact email:", tempcontact);
					ary.push(
						this.annSvc.InsertSMSContactVerification(tempcontact)
					);
				}
				if (tempcontact.SMSPhone) {
					console.log("contact sms:", tempcontact);
					ary.push(
						this.annSvc.InsertEmailContactVerification(tempcontact)
					);
				}
				if (ary && ary.length > 0) {
					forkJoin(ary).subscribe(
						(resp) => {
							this.bindingContext.endGet();
							this.activeModal.close(true);
						},
						(err) => {
							// whatever
							this.bindingContext.endGet();
							this.activeModal.close(false);
						}
					);
				} else {
					// This case should not be possible (adding a contact with no methods of contact)
					this.bindingContext.endGet();
					this.activeModal.close(false);
				}
			})
			.catch((err) => {
				this.bindingContext.endGet();
				this.toastSvc.toastFailure(
					"Error",
					"Error saving contact please try again or contact support if this problem persists."
				);
			});
	}

	CreateForm() {
		// Create the form and it's validators
		this.defaultForm = new FormGroup({
			Name: new FormControl("", [Validators.required]),
			SMSPhone: new FormControl("", [
				EvoPatternValidator(
					this.formSvc.PhoneRegex,
					this.formSvc.PhoneRegexMsg
				),
			]),
			Email: new FormControl("", [
				EvoPatternValidator(
					this.formSvc.EmailRegex,
					this.formSvc.EmailRegexMsg
				),
			]),
		});

		// Subscribe to form change events and validate dirty fields
		this.formValidatorSub = this.defaultForm.valueChanges.subscribe(
			(data) => {
				this.FormValid = this.formSvc.formIsValid(
					this.defaultForm,
					false
				);
			}
		);
	}

	onModalSubmit() {
		if (this.actionType == "Add") {
			this.addContact();
		}
	}

	/**
	 * Formats a value into a phone number and resets the phone field to that value
	 * @param event
	 * @param fieldName
	 */
	public formatPhone(event: any, fieldName: string) {
		var tag = event.target ? event.target : event.srcElement;
		var formattedNumber = this.formatSvc.formatPhone(tag.value);
		(<FormControl>this.defaultForm.controls[fieldName]).setValue(
			formattedNumber
		);
	}

	public canSave(): boolean {
		if (
			this.FormValid &&
			(this.defaultForm.controls["SMSPhone"].value ||
				this.defaultForm.controls["Email"].value)
		) {
			return true;
		}
		return false;
	}
}
